<script setup lang="ts">
import { onMounted, ref } from 'vue'
import db from '@/utils/db'
import { AGREEMENT_KEY } from '@/utils/constant'

const visible = ref(false)
const agree = ref(false)

function sure() {
  if (!agree.value) {
    return
  }
  db.setJson(AGREEMENT_KEY, true)
  visible.value = false
}

onMounted(() => {
  const statementAgree = db.getJson(AGREEMENT_KEY)
  if (!statementAgree) {
    visible.value = true
  }
})
</script>

<template>
  <v-overlay no-click-animation class="statement-modal" persistent v-model="visible">
    <v-card width="16.59rem" height="13.01rem">
      <div class="card-content text-center">
        <div>
          <div class="header">声明</div>
          <div class="content">内部信息，请勿转载或分享。</div>
          <div class="agree-wrapper justify-center">
            <v-checkbox v-model="agree" label="我已知晓" color="#0091df" />
          </div>
        </div>
        <button class="sure-button" @click="sure">确定</button>
      </div>
    </v-card>
  </v-overlay>
</template>

<style lang="scss">
.statement-modal {
  justify-content: center;
  align-items: center;
  $card-border-radius: 0.85rem;

  .v-input__details {
    display: none;
  }

  .v-card {
    border-radius: 0.85rem;
  }

  .header {
    line-height: 1;
    font-size: 0.91rem;
    font-weight: 500;
  }

  .content {
    line-height: 1;
    margin-top: 1.44rem;
    font-size: 0.8rem;
  }

  .card-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: 1.787rem;
  }

  .sure-button {
    background-color: #edf6ff;
    color: #0091df;
    line-height: 2.88rem;
  }

  .agree-wrapper {
    margin-top: 0.8rem;
    display: flex;

    .v-input__control {
      display: inline-block;
    }

    .v-selection-control {
      justify-content: center;
    }

    .v-icon {
      font-size: 1.2rem;
    }

    .v-label {
      width: auto;
      font-size: 0.69rem;
      font-weight: normal;
    }
  }
}
</style>
